<div class="card">
  <div class="float-start card-header card-header-detail"><app-card-secondary-texts [textKey]="titleKey"/></div>
  <div class="card-body">
    <ng-content/>
  </div>
</div>
